<script>
    import {push, pop, replace} from "svelte-spa-router"
    import {environment} from "../environment.js"
    import PaypalButton from '../components/PaypalButton.svelte';
    import { AccountInfoStore } from "../stores";
    
    let accountInfo = {}
    AccountInfoStore.subscribe((data) => {accountInfo = data})
    
    const sendRequestToServer = async (thisServer, thisMessage, thisContent) => {
        const response = await fetch(thisServer, {
            method: 'POST', // or 'PUT'
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({content: thisContent, message: thisMessage})
        })
        
        const output = await response.json()
    
        return output
    }
    
    let numberOfCoins = 0
    
    let paymentAmountInDollar = 1
    
    const processData = () => {
        console.log("Hello World")
    }
    
    const checkCoins = async () => {
        console.log(accountInfo)
        let userCoins = await sendRequestToServer(environment.serverURL, "check coins in account", {username: accountInfo.username})
        accountInfo.coins = userCoins
    }
    
    const handleSuccessPayment = async () => {
        let result = await sendRequestToServer(environment.serverURL, "add coins to account", {username: accountInfo.username, numberOfCoins: paymentAmountInDollar})
        replace("/PaymentSuccessful")
    }
    
    const selectCoinsAmount = async (coinsAmount) => {
        paymentAmountInDollar = coinsAmount
    }

    function open_stripe_payment_6() {
        window.open('https://buy.stripe.com/6oE7sEbwL9gR3As4gh','_blank') // <- This is what makes it open in a new window.
    }

    function open_stripe_payment_60() {
        window.open('https://buy.stripe.com/dR68wI0S73Wxc6YeUX','_blank') // <- This is what makes it open in a new window.
    }

    function open_customer_portal() {
        window.open('https://billing.stripe.com/p/login/cN26p41JE4OJgzS144','_blank') // <- This is what makes it open in a new window.
    }

    
    
    // let listOfCoinsAmount = [0.01, 1, 5, 10, 50, 100]
    let listOfCoinsAmount = [0.01, 1, 6]

    let current_patreon_email = accountInfo["patreon_email"]
    let current_patreon_username = accountInfo["patreon_username"]
    let patreon_status = "Patreon info will be remembered and used to auto deposit coins every month to your account"

    let add_patreon_account = async () => {
        patreon_status = "Waiting for server's response"
        let result = await sendRequestToServer(environment.serverURL, "update patreon info", {"username": accountInfo.username, "patreon_email": current_patreon_email, "patreon_username": current_patreon_username})
        patreon_status = result
    }
    
    </script>
    {#if accountInfo.loginStatus}
    <!-- {#if true} -->
    
        <div class="page">
            <div class="container">
                <h1>Account Dashboard</h1>
                <div class="accessTokenContainer">
                    <h3>Welcome, {accountInfo.username}!</h3>
                    <p>Access Token: {accountInfo.accessToken}</p>
                </div>
    
                <div class="coinContainer">
                    <h3>Your Balance: {accountInfo.coins.toFixed(6)} Coins</h3>
                    <button class="coinCheckButton" on:click={() => {checkCoins()}}><span>Refresh Balance</span></button>
                </div>

                <!-- <div class="flexContainer">
                    <div class="subscriptionOption">
                        <div>
                            <h1>$6.25</h1>
                        </div>
                        <p>Billed Monthly</p>
                        <p>12 coins reset monthly</p>
                        <button class="button" on:click={open_stripe_payment_6}><span>Subscribe</span></button>
                        <button class="button manageButton" on:click={open_customer_portal}><span>Manage</span></button>
                    </div>
    
                    <div class="subscriptionOption">
                        <div>
                            <h1>$5.00</h1>
                        </div>
                        <p>Billed Annually (save 20%)</p>
                        <p>144 coins reset yearly</p>
                        <button class="button" on:click={open_stripe_payment_60}><span>Subscribe</span></button>
                        <button class="button manageButton" on:click={open_customer_portal}><span>Manage</span></button>
                    </div>
                </div> -->

                <div class="patreonInfoBox">
                    <h3>Link Your Patreon Account</h3>
                    <div style="width: 100%; margin-bottom: 15px;">
                        <label for="patreon-email">Patreon Email</label>
                        <input id="patreon-email" class="textInputBox" bind:value={current_patreon_email} placeholder="Enter your Patreon email"/>
                    </div>
                    <!-- <div style="width: 100%; margin-bottom: 15px;">
                        <label for="patreon-username">Patreon Username</label>
                        <input id="patreon-username" class="textInputBox" bind:value={current_patreon_username} placeholder="Enter your Patreon username"/>
                    </div> -->
                    <p style="color: #666; margin-bottom: 15px;">{patreon_status}</p>
                    <button class="button" on:click={() => {add_patreon_account()}}><span>Link Patreon Account</span></button>
                </div>
            </div>
        </div>

    
        {:else}
        <h1>Please login to see this section</h1>
    {/if}
    
    
    <style>
        /* Modern color palette */
        :root {
            --primary-color: #4a6fa5;
            --secondary-color: #166088;
            --accent-color: #4fc3f7;
            --background-color: #f5f7fa;
            --card-color: #ffffff;
            --text-color: #333333;
            --border-color: #e0e0e0;
            --success-color: #66bb6a;
            --warning-color: #ffa726;
        }

        .page {
            width: 100vw;
            height: 100vh;
            background-color: var(--background-color);
            background-image: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
            display: flex;
            align-items: center;
            justify-content: center;
            font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
            color: var(--text-color);
        }

        h1, h3 {
            margin: 0 0 15px 0;
            color: var(--secondary-color);
        }
    
        .container {
            width: 650px;
            max-width: 90%;
            border-radius: 12px;
            box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
            background-color: var(--card-color);
            padding: 30px;
            overflow-y: auto;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            transition: all 0.3s ease;
        }
        
        .container > * {
            margin-bottom: 20px;
            width: 100%;
        }
    
        .accessTokenContainer {
            background-color: rgba(74, 111, 165, 0.1);
            padding: 15px;
            border-radius: 8px;
            width: 100%;
            text-align: center;
            margin-bottom: 20px;
            word-break: break-all;
        }
        
        .coinContainer {
            display: flex;
            align-items: center;
            justify-content: space-between;
            background-color: rgba(79, 195, 247, 0.1);
            padding: 15px 20px;
            border-radius: 8px;
            width: 100%;
            margin-bottom: 20px;
        }

        .coinContainer h3 {
            margin: 0;
            font-size: 1.2rem;
            color: var(--primary-color);
        }

        .patreonInfoBox {
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            border: 1px solid var(--border-color);
            border-radius: 8px;
            padding: 20px;
            width: 100%;
            background-color: rgba(255, 255, 255, 0.8);
            box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
        }
        
        .patreonInfoBox h3 {
            margin-bottom: 15px;
            width: 100%;
            display: flex;
            flex-direction: column;
        }
        
        .textInputBox {
            padding: 10px;
            border: 1px solid var(--border-color);
            border-radius: 4px;
            font-size: 1rem;
            margin-top: 5px;
            width: 100%;
            transition: border-color 0.3s;
        }
        
        .textInputBox:focus {
            border-color: var(--accent-color);
            outline: none;
            box-shadow: 0 0 0 2px rgba(79, 195, 247, 0.2);
        }
    
        .coinCheckButton {
            background-color: var(--primary-color);
            color: white;
            border: none;
            padding: 8px 16px;
            border-radius: 4px;
            cursor: pointer;
            font-weight: 500;
            transition: all 0.3s ease;
        }
        
        .coinCheckButton:hover {
            background-color: var(--secondary-color);
            transform: translateY(-2px);
        }

        .manageButton {
            background-color: #757575;
            color: white;
        }
        
        .manageButton:hover {
            background-color: #616161;
        }

        .flexContainer {
            display: flex;
            justify-content: center;
            gap: 20px;
            width: 100%;
            flex-wrap: wrap;
        }

        .subscriptionOption {
            width: 250px;
            height: auto;
            border-radius: 8px;
            border: 1px solid var(--border-color);
            padding: 20px;
            display: flex;
            align-items: center;
            flex-direction: column;
            background-color: var(--card-color);
            box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
            transition: all 0.3s ease;
        }
        
        .subscriptionOption:hover {
            transform: translateY(-5px);
            box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
        }
        
        .subscriptionOption h1 {
            color: var(--primary-color);
            font-size: 2.5rem;
            margin-bottom: 5px;
        }
        
        .subscriptionOption p {
            margin: 5px 0;
            text-align: center;
            color: #666;
        }

        button {
            cursor: pointer;
            transition: all 0.3s ease;
        }
        
        .button {
            display: inline-block;
            border-radius: 6px;
            background-color: var(--accent-color);
            border: none;
            color: white;
            text-align: center;
            font-size: 1rem;
            font-weight: 600;
            padding: 12px 24px;
            width: 100%;
            transition: all 0.3s;
            cursor: pointer;
            margin: 10px 0;
            box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
        }
        
        .button:hover {
            background-color: #0288d1;
            transform: translateY(-2px);
            box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
        }

        .button span {
            cursor: pointer;
            display: inline-block;
            position: relative;
            transition: 0.3s;
        }

        .button span:after {
            content: '\00bb';
            position: absolute;
            opacity: 0;
            top: 0;
            right: -20px;
            transition: 0.3s;
        }

        .button:hover span {
            padding-right: 25px;
        }

        .button:hover span:after {
            opacity: 1;
            right: 0;
        }
        
        /* Responsive adjustments */
        @media (max-width: 768px) {
            .container {
                padding: 20px;
            }
            
            .coinContainer {
                flex-direction: column;
                align-items: flex-start;
                gap: 10px;
            }
            
            .coinContainer button {
                align-self: flex-end;
            }
            
            .flexContainer {
                flex-direction: column;
                align-items: center;
            }
            
            .subscriptionOption {
                width: 100%;
                margin-bottom: 20px;
            }
        }
    </style>
    